import { useOutletContext } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useSocketState } from '../../helpers/useSocket';

function SettingsDashboard() {
    const { socket, config } = useOutletContext()
    //const [config, setConfig] = useState({});

    const [themeOptions, setThemeOptions] = useState([])
    const [match] = useSocketState('Match');
    const [tournament] = useSocketState('Tournament');

    function updateTheme(data) {
        socket.emit("updateTheme", { ...config, ...data })
    }

    function updateBracketProvider(data) {
        socket.emit("updateBracketProvider", data.bracketProvider )
    }

    function toggleIgnorePlayerNames() {
        socket.emit('modifyMatch', { ignorePlayerNames: !match.ignorePlayerNames });
    }

    function setSheepOMeterAutotoggle(event) {
        socket.emit('modifyMatch', { sheepOMeterAutotoggle: event.target.value });
    }

    function setMinimapAutotoggle(event) {
        socket.emit('modifyMatch', { minimapAutotoggle: event.target.value });
    }

    useEffect(() => {
        socket.emit('registerSettings')

        const host = process.env.NODE_ENV === 'production' ? window.location.host : `${window.location.hostname}:3001`

        fetch(`${window.location.protocol}//${host}/api/themes`)
            .then(response => response.json())
            .then(data => {
                setThemeOptions(data)
            })
    }, [])

    return (
        <div>
            <h1 className='font-bold text-lg'>Live Game Overlay Settings</h1>
			<div className='flex flex-col gap-4'>
              <label className="inline-flex items-center cursor-pointer">
                <span className="ms-3 font-medium text-gray-900 mr-2">Ignore Player Names</span>
                <input type="checkbox" checked={match?.ignorePlayerNames} className="sr-only peer" onChange={toggleIgnorePlayerNames} />
                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
              </label>
              
              <label className="inline-flex items-center cursor-pointer">
                <span className="ms-3 font-medium text-gray-900 mr-2">Turn off sheep-o-meter after</span>
                <input type="number" onChange={setSheepOMeterAutotoggle} value={match?.sheepOMeterAutotoggle || -1} id="sheep-o-meter" min="0" name="sheep-o-meter" />
                <span className="ms-3 font-medium text-gray-900 mr-2">sec ingame</span>
              </label>
              
              <label className="inline-flex items-center cursor-pointer">
                <span className="ms-3 font-medium text-gray-900 mr-2">Turn off minimap after</span>
                    <input type="number" onChange={setMinimapAutotoggle} value={match?.minimapAutotoggle || -1} id="sheep-o-meter" min="0" name="sheep-o-meter" />
                <span className="ms-3 font-medium text-gray-900 mr-2">sec ingame</span>
              </label>
              
			</div>
            <h1 className='font-bold text-lg'>Themes</h1>
            <select value={config.cssTheme} onChange={(e) => updateTheme({ cssTheme: e.target.value })} id="theme" name="theme">
                {themeOptions.map(theme => <option value={theme}>{theme}</option>)}
            </select>
            <h1 className='font-bold text-lg'>Bracket Provider</h1>
            <select value={tournament?.bracketProvider} onChange={(e) => updateBracketProvider({ bracketProvider: e.target.value })} id="bracketProvider" name="bracketProvider">
                <option value={"startgg"}>Start.GG</option>
                <option value={"tourneybot"}>Tourney Bot</option>
            </select>
        </div>
    )
}

export default SettingsDashboard;